import {
  useStore,
  useStoreProps
} from "./P63NRZ4A.js";

// src/checkbox/checkbox-store.ts
import * as Core from "@ariakit/core/checkbox/checkbox-store";
function useCheckboxStoreOptions(_props) {
  return {};
}
function useCheckboxStoreProps(store, props) {
  useStoreProps(store, props, "value", "setValue");
  return store;
}
function useCheckboxStore(props = {}) {
  const store = useStore(() => Core.createCheckboxStore(props));
  return useCheckboxStoreProps(store, props);
}

export {
  useCheckboxStoreOptions,
  useCheckboxStoreProps,
  useCheckboxStore
};
